import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=4d0d49b5&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"
import style0 from "./Workflow.vue?vue&type=style&index=0&id=4d0d49b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d49b5",
  null
  
)

export default component.exports